<template>
  <div>
    <div>
      <el-input-title required>PPC Form</el-input-title>
      <el-form-item :prop="formItemProp">
        <el-button v-if="!ppcEntered" class="mt-05" @click="ppcModalVisible = true">Enter PPC</el-button>
        <el-button v-else class="mt-05" @click="ppcModalVisible = true">Edit PPC</el-button>
      </el-form-item>
    </div>
    <el-dialog class="ppc-dialog" title="Enter PPC" :visible.sync="ppcModalVisible" :close-on-click-modal="false">
      <div class="break-word">
        As this information requires copying into the IJS system, please use appropriate abbreviations and do not type out the element in full.  This will help eliminate re-typing and possible errors occurring. If you don't receive a confirmation immediately you have completed your submission, please contact <a href="mailto:nswisa@nswisa.com">nswisa@nswisa.com</a> to check.
      </div>
      <p class="break-word">
        Select the following link to be taken to a list of <a href="https://www.nswisa.com/ice/images/Forms_and_Documents/AbbreviationsElements_2018_19.pdf" target="_blank" rel="noopener">Abbreviations &amp; Elements&nbsp;</a> which will assist in correct submission format.
      </p>
      <el-form :model="ppcForm" ref="ppcForm" class="w-100 mt-10">
        <el-row class="w-100 mx-0" :gutter="20">
          <el-col :xs="24" :sm="12">
            <div v-for="i in 15" :key="i">
              <div>SP Element {{i}}</div>
              <el-form-item>
                <el-input class="mt-05" v-model="ppcForm[`spElement${i}`]" placeholder="Type here..."/>
              </el-form-item>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12">
            <div v-for="i in 15" :key="i">
              <div>FS Element {{i}}</div>
              <el-form-item>
                <el-input class="mt-05" v-model="ppcForm[`fsElement${i}`]" placeholder="Type here..."/>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row class="w-100 mx-0" :gutter="20">
          <el-col :span="24">
            <div>Comments</div>
            <el-form-item>
              <el-input type="textarea" v-model="ppcForm.comments"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="d-flex justify-content-between">
            <el-button @click="clear">Clear</el-button>
            <div>
              <el-button @click="ppcModalVisible = false">Cancel</el-button>
              <el-button type="primary" class="btn-highlight" @click="submit">Submit PPC</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
const initPPCForm = () => {
  const obj = {};
  for (let i = 1; i <= 15; i++) {
    obj[`spElement${i}`] = '';
  }
  for (let i = 1; i <= 15; i++) {
    obj[`fsElement${i}`] = '';
  }
  obj.comments = '';
  return obj;
};

export default {
  name: 'PPCForm',
  props: [
    'value',
    'formItemProp'
  ],
  data() {
    return {
      ppcModalVisible: false,
      ppcForm: initPPCForm(),
      ppcEntered: false
    };
  },
  mounted() {
    if (this.value) this.ppcForm = this.value;
  },
  methods: {
    clear() {
      this.ppcForm = initPPCForm();
    },
    submit() {
      this.$emit('input', this.ppcForm);
      this.$message.success('PPC form submitted');
      this.ppcModalVisible = false;
      this.ppcEntered = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.ppc-dialog {
  ::v-deep .el-dialog__body {
    display: block !important;
  }
}
</style>
